import { Address, Site, SitesApi, TransceiversApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AddressService } from '@/services/address-service';
import { AddressExtended, SiteExtended } from '@/models/extensions';

export class TransceiverService {
	constructor(private transceiversApi: TransceiversApi = new TransceiversApi()) {}

	public async setDeploymentMeshMode(id: string | number): Promise<{ errorMessage?: string }> {
		if (typeof id === 'string') {
			id = parseInt(id, 10);
		}
		try {
			await this.transceiversApi.setMeshDeploymentMode(id);
			return {};
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`An unknown error occurred setting transceiver mesh mode to deployment`,
			);
		}
	}
}
